<template>
  <div>
    <div class="form-group d-flex flex-column">
      <form @submit.prevent="openSave" enctype='multipart/form-data'>

<!--        <label style="text-align: left; font-weight:900;">-->
<!--          {{$t('ct-label-upload-user-font')}}-->
<!--        </label>-->

        <div class="form" style="text-align: left;">

          <div class="form-group">
            <label class="w-100" id="upload-front-name">{{$t('ct-label-upload-font-name')}}</label>
            <input type="text" placeholder="Name" name="upload-front-name" v-model="description" @keyup="cleanString" @change="cleanString" class="form-control">
          </div>

          <div class="form-group">
            <label id="font" class="d-block">{{$t('ct-label-upload-font-file')}}</label>
            <input type="file" name="font" accept=".ttf,.woff,.woff2"  ref="file" v-on:change="handleFileUpload()">
          </div>
        </div>
        <div class="w-100" style="margin-top: 15px;text-align: center;">
          <button class="btn btn-success" type="submit"> {{labelDesc}}</button>
        </div>
      </form>
    </div>
    <sweet-modal style="z-index: 9000" ref="modalName" class="modal-upload-font" width="30%" hide-close-button blocking>

      <div class="form-group">
        <label for="description_element">{{$t('ct-save-element-name-item')}}</label>
        <input type="text" name="name" v-model="description" id="description_element" class="form-control"
               :class="{ 'is-invalid': errors.has('description')}" @keyup="errors.clear('description')" required>
        <span
          v-if="errors.has('description')"
          class="invalid-feedback"
          v-text="errors.get('description')"
        ></span>
      </div>

      <button slot="button" class="btn btn-outline-light mt-2" @click="closeSave">{{ $t('ct-cancel') }}
      </button>
      <button slot="button" class="btn btn-success mt-2" @click="save">{{ $t('ct-save') }}</button>

    </sweet-modal>
  </div>
</template>

<script>

	import {SweetModal} from 'sweet-modal-vue';
	import Errors from '../../../js/base/Errors';
	import {mapGetters} from 'vuex';
	import axios from 'axios';

	export default {
		name: 'FontUploadComponent',
		components: {
			SweetModal,
		},
		props: {
			defaultFontOptions: {
			type: Array,
			required: true
			}
		},
		data() {
			return {
				errors: new Errors(),
				description: '',
				file: '',
				element: null,
				labelDesc: 'Save as default Font',
				headers: {
					// 'authorization': 'Bearer ' + localStorage.getItem('token')
					'Auth': 'eyJpdiI6InNkVVdBR2hvcVp4eFhJeklLTlN0RGc9PSIsInZhbHVlIjoiZjZjTFNVY043U0ZrV0VnUE1zUEVOdz09IiwibWFjIjoiNmQyZTcxZWIwOGY2MjA3YTY4NzI0Y2E2MzU3NWNkNjA1Nzk0NmM1NmZkZjU2ZjZiYWFmYmIyNmIxMDNlYzVkYSJ9'
				}
			};
		},
		methods: {
			...mapGetters({getUser: 'user'}),

			cleanString() {
				this.description = this.description.replace(/[^a-zA-Z ]/g, "");
			},

			afterUpload() {

				console.log('a');
			},
			handleFileUpload() {
				this.file = this.$refs.file.files[0];
			},
			openSave() {

				if (this.description === '') {
					this.$snotify.error(
						'Name is required'
					);
				} else {
					this.save();
				}
			},

			closeSave() {
				this.description = '';
				this.$refs.modalName.close();
			},

			extensionFont(path) {
				if (path.indexOf("ttf") !== -1) {
					return 'truetype';
				}
				if (path.indexOf("otf") !== -1) {
					return 'opentype';
				}
				if (path.indexOf("woff2") !== -1) {
					return 'woff2';
				}
				if (path.indexOf("woff") !== -1) {
					return 'woff';
				}
			},

			save() {
				let vm = this;

				if (this.description && this.description.length > 0 && this.description.trim().length > 0) {

					let formData = new FormData();
					formData.append('font', this.file);

					let baseName = this.description.trim();
					let uniqueName = baseName;
					let counter = 1;

					while (this.defaultFontOptions.some(opt => opt.text.toLowerCase() === uniqueName.toLowerCase())) {
						uniqueName = `${baseName}${counter}`;
						counter++;
					}

					this.description = uniqueName;

					formData.append('name', this.description);
					formData.append('email', this.getUser().email);

					this.$loading.show();

					axios.post('https://sitebuilder-admin.kub.app.builderall.com/user_fonts/store',
						formData,
						{
							headers: {
								'Content-Type': 'multipart/form-data',
								'Auth': 'eyJpdiI6InNkVVdBR2hvcVp4eFhJeklLTlN0RGc9PSIsInZhbHVlIjoiZjZjTFNVY043U0ZrV0VnUE1zUEVOdz09IiwibWFjIjoiNmQyZTcxZWIwOGY2MjA3YTY4NzI0Y2E2MzU3NWNkNjA1Nzk0NmM1NmZkZjU2ZjZiYWFmYmIyNmIxMDNlYzVkYSJ9',
							}
						}
					).then(function (res) {

						let fonts = res.data.data;

						let style = document.createElement('style');

						vm.$root.$emit('addFonts', {text: fonts.name, value: fonts.name});
						vm.$root.$emit('addFontsCk', {text: fonts.name, value: fonts.name});

						style.innerHTML += `@font-face {  font-family: '` + fonts.name + `';  src: url('https://cheetah-admin.builderall.com/storage/` + fonts.path + `') format('` + vm.extensionFont(fonts.path) + `');}`;
						style.innerHTML += `@font-face {  font-family: '` + fonts.name + `';  src: url('https://sitebuilder-admin.kub.app.builderall.com/storage/` + fonts.path + `') format('` + vm.extensionFont(fonts.path) + `');}`;
						
						document.head.appendChild(style);

						vm.$loading.hide();

						vm.$snotify.success(
							'Successfully'
						);
					})
					.catch(error => {
						this.$loading.hide();

						this.$snotify.error(
						'Something wrong;'
					);
					});
				} else {
					this.$snotify.error(
						'Something wrong;'
					);
				}

				this.$root.$emit('hideFontUpload');
			},

			setValues() {
				this.labelDesc = this.$t('ct-save-personal-font', 'Save as Personal Font')

				this.description = '';
				this.file = '';
				this.$refs.file.value = '';
			}
		}
	};
</script>

<style scoped lang="scss">
  .form-group {
    overflow: hidden;
  }

  .image-item {
    width: 140px;
    height: 70px;
    display: inline-block;
    cursor: pointer;
    text-align: center;
  }

  .image-item.focused {
    outline: 2px solid blue;
  }

  .image-item img {
    width: 100px;
    height: 50px;
  }

  .image-name {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: block;
  }

</style>

<style lang="scss">
  .modal-upload-font .sweet-modal {

    .sweet-content {
      max-height: 70vh !important;
      overflow: auto;
      text-align: left;
    }

    .btn {
      cursor: pointer;
      margin-left: 5px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/editor/resources/UploadFont.vue